module.exports = __webpack_public_path__ + "../assets/fonts/Neutra2Text-Bold.b2f1a2a17b0c8e8cb83493b412d3d967.otf";